// Vendor
import classnames from 'classnames';
import * as React from 'react';

// Internal
import { Logo } from '@src/svg/Logo';
import { Menu } from '@src/svg/Menu';

// Styles
import styles from './styles.module.css';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = (props) => {
  const { onMenuClick } = props;
  const classes = classnames('tup-header', styles.component);

  return (
    <header className={classes}>
      <button className={styles.menu} onClick={onMenuClick}>
        <Menu />
      </button>
      <a
        className={styles.logo}
        href="https://www.thredup.com"
        rel="noopener noreferrer"
        target="_blank"
      >
        <Logo height={23} />
      </a>
    </header>
  );
};

export { Header };
